import { siteCulture } from 'settings/vistaprintContext';
import { getLocalizedText } from '@vp-dst/localization-util';

export default class DifyOrderDTO {
    constructor({ productName, productPfid, productConfigurations, note, uploads, uploadRefs, difyServiceQuantity, multiselectedProducts }) {
        const model = window.model.BriefViewModel;

        this.SelectedProduct = {
            Name: productName,
            Pfid: productPfid,
            DifyServiceQty: difyServiceQuantity,
        };

        this.ProductConfigJson = JSON.stringify(productConfigurations.map(productConfiguration => ({
            Name: productConfiguration.name,
            DisplayName: productConfiguration.displayName,
            Value: productConfiguration.value,
            Id: productConfiguration.id,
            Key: productConfiguration.key,
        })));

        this.Brief = {
            Sites: [],
            Notes: note,
            Uploads: uploads,
            UploadRefs: uploadRefs,
            TemplatesJson: model.TemplatesJson,
            DocumentId: model.DocumentId,
        };

        this.DesignServicePfid = model.DesignServicesPfid;
        this.Path = model.Path;
        this.Locale = siteCulture;
        this.SocialMediaAssetsRequested = multiselectedProducts;

        this.validate = this.validate.bind(this);
    }

    validate() {
        if (!this.SelectedProduct || !this.SelectedProduct.Name) {
            return getLocalizedText('please-select-a-product-before-continuing');
        }
    
        const brief = this.Brief;
        if (!brief.Notes || brief.Notes.length === 0) {
            return getLocalizedText('please-describe-your-design-idea');
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/designServices/dtos/DifyOrderDTO.js